import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProfileService } from './profile.service';
import { SharedModule } from 'app/shared/shared.module';

@Component({
	selector: 'jhi-page-ribbon',
	encapsulation: ViewEncapsulation.None,
	exportAs: 'fuseLoadingBar',
	imports: [SharedModule],
	template: `
		<div class="ribbon" *ngIf="ribbonEnv$ | async as ribbonEnv">
			<a href="" jhiTranslate="global.ribbon.{{ ribbonEnv }}">{{
				{ dev: 'Desenvolvimento' }[ribbonEnv] || ''
			}}</a>
		</div>
	`,
	styleUrls: ['./page-ribbon.component.scss'],
	standalone: true,
})
export class PageRibbonComponent implements OnInit {
	ribbonEnv$?: Observable<string | undefined>;

	constructor(private profileService: ProfileService) {}

	ngOnInit(): void {
		this.ribbonEnv$ = this.profileService.getProfileInfo().pipe(
			map((profileInfo) => {
				return profileInfo.ribbonEnv;
			})
		);
	}
}
